import AcceptedCookies from "../types/AcceptedCookies";

const siteCookies = [
    {
        "title": "Necessary",
        "description": "Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.",
        "disabled": true,
        "name": "necessary",
        "services": [
            {
                "name": "Google Fonts",
                "url": "https://business.safety.google/privacy/?hl=en",
                "description": "This is a collection of fonts for commercial and personal use.",
                "cookies": []
            },
            {
                "name": "Google Tag Manager",
                "url": "https://business.safety.google/privacy/?hl=en",
                "description": "This is a tag management system. Via Google Tag Manager, tags can be integrated centrally via a user interface. Tags are small sections of code that can track activities. Script codes of other tools are integrated via the Google Tag Manager. The Tag Manager allows to control when a particular tag is triggered.",
                "cookies": []
            },
            {
                "name": "cloudfront.net",
                "url": "https://aws.amazon.com/privacy/",
                "description": "This is a content delivery network provided by Amazon. The use of a CDN enables the user to make content available to you for retrieval more quickly with the help of regionally or internationally distributed servers. When you access this content, a connection is established between you and the respective servers of the CDN, whereby personal data may be transmitted.",
                "cookies": []
            },
            {
                "name": "Stripe",
                "url": "https://stripe.com/privacy",
                "description": "Stripe is used to accept online payments, manage subscriptions, and handle billing, making it easy for businesses to process transactions securely and efficiently.",
                "cookies": [
                    {
                        "name": "__stripe_sid",
                        "description": "This is a session ID set by Stripe to identify a single user session. It helps track user activity during a single visit to the website.",
                        "duration": "1 day",
                        "type": "cookie"
                    },
                    {
                        "name": "__stripe_mid",
                        "description": "This is a machine ID used to identify the user's device on repeated visits. It helps Stripe detect and prevent fraudulent activity.",
                        "duration": "1 year",
                        "type": "cookie"
                    }
                ]
            },
            {
                "name": "Facebook Pixel",
                "url": "https://www.facebook.com/privacy/policy/",
                "description": "This is a Tracking technology offered by Facebook and used by other Facebook services. It is used to track interactions of visitors with websites (\"Events\") after they have clicked on an ad placed on Facebook or other services provided by Meta (\"Conversion\").",
                "cookies": [
                    {
                        "name": "messaging_plugin_#",
                        "description": "This service uses different means of storing information on a user’s device as listed below.",
                        "duration": "-",
                        "type": "cookie"
                    },
                    {
                        "name": "fr",
                        "description": "This service uses different means of storing information on a user’s device as listed below.",
                        "duration": "-",
                        "type": "cookie"
                    },
                    {
                        "name": "_fbp",
                        "description": "This service uses different means of storing information on a user’s device as listed below.",
                        "duration": "-",
                        "type": "cookie"
                    },
                    {
                        "name": "pxcelBcnLcy",
                        "description": "This service uses different means of storing information on a user’s device as listed below.",
                        "duration": "-",
                        "type": "cookie"
                    }
                ]
            },
            {
                "name": "Amplitude",
                "url": "https://amplitude.com/privacy",
                "description": "This is a product analytics software for website and apps. It is used to receive insights about the usage of websites and platforms.",
                "cookies": [
                    {
                        "name": "amplitude_unsent_#",
                        "description": "Registers data on visitors' website-behaviour. This is used for internal analysis and website optimization.",
                        "duration": "-",
                        "type": "cookie"
                    },
                    {
                        "name": "amplitude_unsent_identify_#",
                        "description": "Registers data on visitors' website-behaviour. This is used for internal analysis and website optimization.",
                        "duration": "-",
                        "type": "cookie"
                    },
                    {
                        "name": "amp_cookie_test#",
                        "description": "Registers statistical data on users' behaviour on the website. Used for internal analytics by the website operator.",
                        "duration": "session",
                        "type": "cookie"
                    },
                    {
                        "name": "amp_#",
                        "description": "Registers statistical data on users' behaviour on the website. Used for internal analytics by the website operator.",
                        "duration": "1 year",
                        "type": "cookie"
                    },
                    {
                        "name": "amplitude_#",
                        "description": "Registers statistical data on users' behaviour on the website. Used for internal analytics by the website operator.",
                        "duration": "1 year",
                        "type": "cookie"
                    }
                ]
            },
            {
                "name": "Conversion Linker",
                "url": "https://business.safety.google/privacy/?hl=en",
                "description": "This service stores click data to measure conversions effectively.",
                "cookies": [
                    {
                        "name": "_gcl_aw, _gcl_dc, _gcl_gb",
                        "description": "This is the prefix used as part of the cookie names. The conversion linker tag sets ad click information in cookies and uses the top-most domain and root level path.",
                        "duration": "1 day",
                        "type": "cookie"
                    }
                ]
            },
            {
                "name": "DoubleClick Ad",
                "url": "https://business.safety.google/privacy/?hl=en",
                "description": "This is an advertising service. With this service it is possible to provide relevant ads to users and get campaign reports.",
                "cookies": [
                    {
                        "name": "test_cookie",
                        "description": "Test for cookie setting permissions in user's browser.",
                        "duration": "1 day",
                        "type": "cookie"
                    },
                    {
                        "name": "IDE",
                        "description": "Contains a randomly generated user ID. Using this ID, Google can recognize the user across different websites across domains and display personalized advertising.",
                        "duration": "1 day",
                        "type": "cookie"
                    }
                ]
            },
            {
                "name": "Google Ads",
                "url": "https://business.safety.google/privacy/",
                "description": "This is an advertising service. This service can be used to show personalised or non-personalised advertisement to users.",
                "cookies": [
                    {
                        "name": "NID",
                        "description": "This is used to provide advertisements or retargeting.",
                        "duration": "6 months",
                        "type": "cookie"
                    },
                    {
                        "name": "__gads",
                        "description": "This is used to provide advertisements or retargeting.",
                        "duration": "1 year, 1 month",
                        "type": "cookie"
                    },
                    {
                        "name": "pm_sess",
                        "description": "This is used to make sure that requests come from a user.",
                        "duration": "30 minutes",
                        "type": "cookie"
                    },
                    {
                        "name": "ANID",
                        "description": "This is used to show advertisements on websites outside of Google.",
                        "duration": "1 year, 1 month",
                        "type": "cookie"
                    },
                    {
                        "name": "_gcl_au",
                        "description": "This is used to store and track conversions.",
                        "duration": "2 months, 29 days",
                        "type": "cookie"
                    },
                    {
                        "name": "FPGCLAW",
                        "description": "This cookie is used to track campaign related information on the user.",
                        "duration": "2 months, 29 days",
                        "type": "cookie"
                    },
                    {
                        "name": "FPGCLGB",
                        "description": "This cookie is used to track campaign related information on the user.",
                        "duration": "2 months, 29 days",
                        "type": "cookie"
                    },
                    {
                        "name": "_gcl_gb",
                        "description": "This cookie is used to track campaign related information on the user.",
                        "duration": "2 months, 29 days",
                        "type": "cookie"
                    },
                    {
                        "name": "_gac_gb_<wpid>",
                        "description": "This cookie is used to track campaign related information on the user.",
                        "duration": "2 months, 29 days",
                        "type": "cookie"
                    },
                    {
                        "name": "_gcl_aw",
                        "description": "This cookie is set when a user arrives at the website via a click on a Google ad.",
                        "duration": "2 months, 29 days",
                        "type": "cookie"
                    },
                    {
                        "name": "YSC",
                        "description": "This is used to store and track interaction.",
                        "duration": "session",
                        "type": "cookie"
                    },
                    {
                        "name": "1P_JAR",
                        "description": "This is used to collect information about how the end user uses the website and any advertising that the end user may have seen before visiting the said website.",
                        "duration": "30 days",
                        "type": "cookie"
                    },
                    {
                        "name": "AID",
                        "description": "This is used to link activities on other devices the user has previously logged into with a Google account.",
                        "duration": "1 year, 1 month",
                        "type": "cookie"
                    },
                    {
                        "name": "FPAU",
                        "description": "This is used to collect information about the users and their activity on the website through embedded elements with the purpose of analytics and reporting.",
                        "duration": "2 months, 29 days",
                        "type": "cookie"
                    }
                ]
            }
        ]
    },
    {
        "title": "Statistics",
        "description": "Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.",
        "disabled": false,
        "name": "statistics",
        "services": [
            {
                "name": "Hotjar",
                "url": "https://www.hotjar.com/legal/policies/privacy/",
                "description": "Hotjar is used to understand how users interact with your website through heatmaps, helping you improve user experience and optimize conversions.",
                "cookies": [
                    {
                        "name": "_hjSession_#",
                        "description": "Collects statistics on the visitor's visits to the website, such as the number of visits, average time spent on the website and what pages have been read.",
                        "duration": "1 day",
                        "type": "cookie"
                    },
                    {
                        "name": "_hjSessionUser_#",
                        "description": "Collects statistics on the visitor's visits to the website, such as the number of visits, average time spent on the website and what pages have been read.",
                        "duration": "1 year",
                        "type": "cookie"
                    }
                ]
            }
        ]
    },
    /*{
        "title": "Marketing",
        "description": "These technologies are used by advertisers to serve ads that are relevant to your interests.",
        "disabled": false,
        "name": "marketing",
        "services": [

        ]
    }*/
]

const checkAccess = (type: string, userCookies: Record<string, boolean>): boolean => {
    return !(type in userCookies) || userCookies[type];
};

const getValues = (initial: boolean) => {
    return siteCookies.reduce<AcceptedCookies>((acc, item) => {
        acc[item.name] = item.disabled ? true : initial;
        return acc;
    }, {})
}

const getCookieByName = (name: string) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
}

export {
    siteCookies,
    getValues,
    checkAccess,
    getCookieByName
}